module.exports = {
    DAYS_OF_THE_WEEK: Object.freeze([
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
        'Воскресенье',
    ]),
    SCHEDULE: Object.freeze([
        {
            open_at: '',
            close_at: '',
            enabled: true,
        },
        {
            open_at: '',
            close_at: '',
            enabled: true,
        },
        {
            open_at: '',
            close_at: '',
            enabled: true,
        },
        {
            open_at: '',
            close_at: '',
            enabled: true,
        },
        {
            open_at: '',
            close_at: '',
            enabled: true,
        },
        {
            open_at: '',
            close_at: '',
            enabled: false,
        },
        {
            open_at: '',
            close_at: '',
            enabled: false,
        },
    ]),
}